import { formatSheet } from '@common/xlsxExport/xlsxExport';
import downloadXlsxFile from './downloadXlsxFile';

/** @typedef {object} SheetDefinition
 * @property {object[]}         [columnDefinitions]                         Array of AgGrid column definitions.
 * @property {string}           name                                      Name of the generated sheet.
 * @property {SheetExportTypes} type                                      Type of the generated sheet.
 * @property {object|array}     data                                      Sheet data that will be passed down to the builders.
 * @property {object}           options
 * @property {boolean}          [options.shouldDisplayZero]               Whether to display zero as zero or dash, taken from user preferences.
 * @property {boolean}          [options.hideDecimals]                    Whether to display values to the right of the decimal point, taken from user preferences.
 * @property {boolean}          [options.negativeMinus]                   Whether to display negative values with a minus or in brackets, taken from user preferences.
 * @property {boolean}          [options.omitExportIfNull]                Whether to display null values as nulls or zeros.
 * @property {boolean}          [options.addTimestamp]                    Whether to add a timestamp in the metadata rows.
 * @property {boolean}          [options.splitDescriptionColumn]          Whether to split description column into account and accountDescription for detail rows.
 * @property {boolean}          [options.isFunctionalCurrency]             Whether Functional Currency is used.
 * @property {number}           [options.numberOfAdditionalRowsToStick]   Number of extra rows to stick below the header.
 * @property {number}           [options.numberOfColumnsToStick]          Number of columns to stick on the left side.
 * @property {[any]}            [options.additionalMetadata]              Additional data rendered in metadata rows.
 * @property {number}           [options.headerRowHeight]                 Hight of header row.
 */

/** Export a file using Excelgen.
 * @param {object}              data
 * @param {SheetDefinition[]}   data.sheetData                          Array with sheet definitions.
 * @param {object}              data.metadata
 * @param {string}              data.metadata.fileName                  Filename of the generated file.
 * @param {boolean=}             data.metadata.disableHeaderRendering    Whether to render the metadata rows at all.
 *
 * @return {Promise<*>}
 **/
const xlsxExport = function(data) {
  const formattedSheets = data.sheetData.map(formatSheet(data.metadata));

  return downloadXlsxFile(data.metadata.fileName, formattedSheets);
};

export default xlsxExport;
